import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerAndroidScanningLibrary,
  CapacitorBarcodeScannerCameraDirection,
  CapacitorBarcodeScannerScanOrientation,
  CapacitorBarcodeScannerTypeHintALLOption,
} from '@capacitor/barcode-scanner';
import { Capacitor } from '@capacitor/core';

const PLUGIN_NAME = 'CapacitorBarcodeScanner';

export function canUseNativeBarcodeScanner(): boolean {
  return (
    Capacitor.getPlatform() === 'android'
    && Capacitor.isNativePlatform()
    && Capacitor.isPluginAvailable(PLUGIN_NAME)
  );
}

export async function scanNativeBarcode(): Promise<string | null> {
  const result = await CapacitorBarcodeScanner.scanBarcode({
    hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
    cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK,
    scanOrientation: CapacitorBarcodeScannerScanOrientation.ADAPTIVE,
    scanInstructions: 'Center the barcode in the frame',
    cancelButtonAccessibilityLabel: 'Cancel barcode scan',
    torchButtonOnAccessibilityLabel: 'Turn flashlight off',
    torchButtonOffAccessibilityLabel: 'Turn flashlight on',
    android: {
      scanningLibrary: CapacitorBarcodeScannerAndroidScanningLibrary.MLKIT,
    },
  });

  const barcode = result.ScanResult.trim();
  return barcode || null;
}

export function isNativeScanCancellation(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;

  const candidate = error as { code?: unknown; message?: unknown };
  const details = `${String(candidate.code ?? '')} ${String(candidate.message ?? '')}`;
  return /cancel/i.test(details);
}
